import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Manufacture from './pages/Manufacture/Manufacture';
import Partnership from './pages/Partnership/Partnership';
import Contact from './pages/Contact/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function PageLoader() {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [pathname]);

  if (!loading) return null;

  return (
    <div className="page-loader" aria-live="polite" aria-label="Loading page">
      <div className="page-loader__breathe">
        <div className="page-loader__spinner-wrap">
          <div className="page-loader__spinner" />
        </div>
        <p className="page-loader__text">Loading</p>
      </div>
    </div>
  );
}


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <PageLoader />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/manufacture" element={<Manufacture />} />
          <Route path="/partnership" element={<Partnership />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;